import { useState } from "react"

export const BookingState = () => {
	const [bsrform, setBSRForm] = useState({
		status: {value:0, msg:'', bstat:false },
		from: {value:'', msg:'', bstat:false },
		to: {value:'', msg:'', bstat:false },
		filterBy: {value:1, msg:'', bstat:false },
	})
	const [bsdata, setBSdata] = useState([])
	const [bstat, setBStat] = useState([
        {id:1, name:'Booked'},
        {id:2, name:'Check In'},
        {id:3, name:'Check Out'},
    ])
	const [loadData, setLoadData] = useState(false)
	const [isLoader, setIsLoader] = useState(false)
	const [lid, setLid] = useState(0)
	const [vcount, setVcount] = useState(0)

	return {
		bsrform:{data:bsrform, set: setBSRForm},
		bsdata:{data:bsdata, set: setBSdata},
		bstat:{data:bstat, set: setBStat},
		loadData: {data: loadData, set: setLoadData },
		isLoader: {data: isLoader, set: setIsLoader },
		lid: {data: lid, set: setLid },
		vcount: {data: vcount, set: setVcount}
	}
}
